import ListeVisitesMedicales from "@/views/mdt/societe/societeDetails/historique-visites-medicales/liste-visites-medicales"
import RecapVisitesMedicales from "@/views/mdt/societe/societeDetails/historique-visites-medicales/recap-visites-medicales"

export default {
  name: 'historique-visites-medicales',
  components: {ListeVisitesMedicales,RecapVisitesMedicales},
  props: [],
  data () {
    return {
      selected_visite:null,
      showing_liste: true

    }
  },
  computed: {
    
  },
  mounted () {

  },
  methods: {
    switchToVisite: function(visite){
      this.showing_liste = !this.showing_liste 
      this.selected_visite = visite
    }, 
    
  }
}


